import { mapActions } from "vuex";

export default  {
	methods: 
    {
		...mapActions({			
			saveAll: 'crudStore/saveAll',
		}),
		async actualizarFtn()
		{
			try{

			}catch{

			}
		},
		async saveForm(event)
		{
			try{
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'pacienteNuevoFtn':  
							await this.updateDataPost({ 
								data: { 
									data: [],
									route: 'save_paciente', 
									tablaPost: ['datos_pacientes']
								}
							}) 
							break;
						case 'inactivarFtn':  
							await this.updateDataPost({ 
									data: { 
										data: [],
										route: 'inactive_paciente', 
										tablaPost: ['datos_pacientes']
									}
								}) 
						case 'garantiaFtn':  
							await this.updateDataPost({ 
									data: { 
										data: [],
										route: 'save_garantia', 
										tablaPost: ['info_garantia']
									}
								})
							await this.updateDataForm({ state: 'info_garantia/id_datos_pacientes', data: this.dataGet[this.namePath].data[this.indexData].datos_pacientes.id})
							await this.updateDataForm({ state: 'info_garantia/estado', data: 'examen'})
						break;
					}
				}

				await this.save(event.save)
				
				if(event.ftn!==undefined)
				{
					switch(event.ftn)
					{
						case 'pacienteNuevoFtn':  
							if(this.indexData!==false)
							{
								await this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath]})
							}
							else
							{								
								let datos= {}
								datos.datos_pacientes = await this.gettersDatalist('datos_pacientes', this.dataForm[this.namePath].datos_pacientes.name)[0]
								await this.pushDataGet({ data: datos})
							}		
							this.updateDataGet({ index: this.indexData, data: this.dataForm[this.namePath] })														
						break;
						case 'inactivarFtn':  
							this.spliceDataGet(this.indexData)							
						break;
					}
				}

				await this.resetGlobal({state: 'indexData'}) 								
				await this.resetGlobal({state: 'openModal'}) 
				await this.resetDataForm()
				
				return true
			}
			catch{

			}					
		},
		actives(index){
			this.active=[false,false,false,false]
			this.active[index]=true;
		  }		
	},
}